module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-800.a32ea157.svg";